import type { moduleFederationPlugin } from './types/plugins';

export const createModuleFederationConfig = (
  options: moduleFederationPlugin.ModuleFederationPluginOptions,
): moduleFederationPlugin.ModuleFederationPluginOptions => {
  return options;
};
